// packages/components/src/agent_profile/showcase/EtaPill.tsx
import React from 'react';
import { Clock } from 'lucide-react';

type Props = {
  minDays?: number;
  maxDays?: number;
  text?: string; // if provided, overrides min/max formatting
  size?: 'sm' | 'md';
  className?: string;
  ariaLabel?: string;
};

export function EtaPill({ minDays, maxDays, text, size = 'md', className, ariaLabel }: Props) {
  const label =
    text ||
    (typeof minDays === 'number' && typeof maxDays === 'number'
      ? `ETA ${minDays}–${maxDays} days`
      : 'ETA');

  const pad = size === 'md' ? 'px-3 py-2' : 'px-2.5 py-1.5';
  const textCls = size === 'md' ? 'text-sm' : 'text-xs';
  const iconCls = size === 'md' ? 'w-4.5 h-4.5' : 'w-4 h-4';

  return (
    <span
      className={[
        'inline-flex items-center gap-2',
        'bg-slate-50 text-slate-900',
        'border-2 border-black rounded-xl',
        'shadow-[2px_2px_0_0_rgb(17,24,39)]',
        pad,
        textCls,
        className || '',
      ].join(' ')}
      aria-label={ariaLabel || 'Estimated time'}
    >
      <Clock className={iconCls} />
      <span className="font-bold">{label}</span>
    </span>
  );
}

export default EtaPill;
